import React from 'react'
import { Navigation, Pagination, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import AnchorLink from 'react-anchor-link-smooth-scroll'

import Slide1 from '../../images/slider/slide-1.jpg'
import Slide2 from '../../images/slider/slide-2.jpg'
import Slide3 from '../../images/slider/slide-33.jpg'
// import Slide6 from '../../images/slider/hero-text.jpg'

/* heroTeam */
// import heroTeam from '../../images/team/hero-team/1.jpg'
// import heroTeam2 from '../../images/team/hero-team/2.jpg'
// import heroTeam3 from '../../images/team/hero-team/3.jpg'
// import heroTeam4 from '../../images/team/hero-team/4.jpg'
import arrow from '../../images/down-arrow.svg'
// import { Link } from 'react-router-dom'

const Hero = () => {
  return (
    <section className="wpo-hero-slider">
      <Swiper
        className="swiper-container"
        modules={[Navigation, A11y, Pagination]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        speed={1800}
        parallax={true}
        navigation={false}
        pagination={{
          clickable: true,
          el: '.swiper-pagination',
          type: 'fraction',
          renderFraction: (currentClass, totalClass) => {
            return `<span class="${currentClass}"></span> / <span class="${totalClass}"></span>`
          },
        }}
      >
        <SwiperSlide>
          <div
            className="slide-inner slide-bg-image"
            style={{
              backgroundImage: `url(${Slide1})`,
            }}
          >
            <div className="container">
              <div className="slide-content">
                <div className="slide-sub-title">
                  <h2>Fullamoda </h2>
                  {/* <span>
                    <img src={Slide6} alt="" />
                  </span> */}

                  <h2> New Collection</h2>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div
            className="slide-inner slide-bg-image"
            style={{ backgroundImage: `url(${Slide2})` }}
          >
            <div className="container">
              <div className="slide-content">
                <div className="slide-sub-title">
                  <h2> </h2>
                  {/* <span>
                    <img src={Slide6} alt="" />
                  </span> */}

                  <h2> New Collection</h2>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div
            className="slide-inner slide-bg-image"
            style={{ backgroundImage: `url(${Slide3})` }}
          >
            <div className="container">
              <div className="slide-content">
                <div className="slide-sub-title">
                  <h2>Fullamoda </h2>
                  {/* <span>
                    <img src={Slide6} alt="" />
                  </span> */}

                  <h2> New Collection</h2>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <div className="swiper-pagination"></div>
      </Swiper>
      {/* <div className="hero-team">
                <ul>
                    <li><img src={heroTeam} alt="hero-team" /></li>
                    <li><img src={heroTeam2} alt="hero-team" /></li>
                    <li><img src={heroTeam3} alt="hero-team" /></li>
                    <li><img src={heroTeam4} alt="hero-team" /></li>
                    <li>
                        <Link to="/">
                            <svg width="32" height="8" viewBox="0 0 32 8" fill="none">
                                <rect width="8" height="8" rx="4" fill="white" />
                                <rect x="12" width="8" height="8" rx="4" fill="white" />
                                <rect x="24" width="8" height="8" rx="4" fill="white" />
                            </svg>
                        </Link>
                    </li>
                </ul>
                <span>Meet Our Team</span>
            </div> */}
      {/* <AnchorLink href="#about" className="scroll-btn">
        <span>Scroll For More</span>
        <div className="scroll-befor">
          <img src={arrow} alt="" />
        </div>
      </AnchorLink> */}
    </section>
  )
}

export default Hero
